import { render } from "./ProjectLimitModal.vue?vue&type=template&id=c0019096"
import script from "./ProjectLimitModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectLimitModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/project/ProjectLimitModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c0019096"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c0019096', __exports__)) {
    api.reload('c0019096', __exports__)
  }
  
  module.hot.accept("./ProjectLimitModal.vue?vue&type=template&id=c0019096", () => {
    api.rerender('c0019096', render)
  })

}


export default __exports__